module.exports = __webpack_public_path__ + "img/a2.59066c35.jpg";